var _path, _path2, _path3, _path4, _path5, _path6, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 944,
    viewBox: "0 0 1440 944",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.979 0H460L41.7958 630H0V314.877L208.979 0Z",
    fill: "#00269A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M211 838.812L-6.73226e-05 523L-3.05176e-05 944L211 944L211 838.812Z",
    fill: "#D50057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1233 0L1233 417L1440 417L1440 -9.04826e-06L1233 0Z",
    fill: "#FFDD00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1440 944L1440 732L1123 944L1440 944Z",
    fill: "#0E0333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1033 659H820V871H1033V659Z",
    fill: "#D30505"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M695.269 18.0003C670.524 17.9474 646.319 25.1806 625.722 38.7856C605.124 52.3906 589.061 71.754 579.567 94.423C570.072 117.092 567.574 142.047 572.389 166.125C577.203 190.204 589.114 212.324 606.612 229.682C624.109 247.04 646.407 258.854 670.68 263.63C694.952 268.406 720.108 265.929 742.96 256.51C765.811 247.092 785.331 231.156 799.046 210.723C812.76 190.291 820.053 166.28 820 141.732C820 108.916 806.859 77.4449 783.467 54.2404C760.076 31.036 728.35 18.0003 695.269 18.0003Z",
    fill: "#00B1E0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 1440,
    height: 944,
    fill: "#00269A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.e9fd7cc25afc209911c6b087a6020817.svg";
export { ForwardRef as ReactComponent };